// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
const installedChunks = {
	251: 0
};

const uniqueName = "PatronTechnologyCheckoutWrapper";
const loadingAttribute = "data-webpack-loading";
const loadStylesheet = (chunkId, url, done) => {
	let link, needAttach, key = "chunk-" + chunkId;

	const links = document.getElementsByTagName("link");
	for(var i = 0; i < links.length; i++) {
		const l = links[i];
		if(l.rel == "stylesheet" && (l.href == url || l.getAttribute("href") == url || l.getAttribute("data-webpack") == uniqueName + ":" + key)) { link = l; break; }
	}
	if(!done) return link;

	if(!link) {
		needAttach = true;
		link = document.createElement('link');
		link.charset = 'utf-8';
		if (__webpack_require__.nc) {
			link.setAttribute("nonce", __webpack_require__.nc);
		}
		link.setAttribute("data-webpack", uniqueName + ":" + key);

		link.setAttribute(loadingAttribute, 1);
		link.rel = "stylesheet";
		link.href = url;
	}
	let timeout;
	const onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if(event && event.type != "load") link.parentNode.removeChild(link)
		done(event);
		if(prev) return prev(event);
	};
	if(link.getAttribute(loadingAttribute)) {
		timeout = setTimeout(onLinkComplete.bind(null, undefined, { type: 'timeout', target: link }), 120000);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: 'load', target: link });

	if (needAttach) {
		document.head.appendChild(link);
	}
	return link;
};
__webpack_require__.f.css = (chunkId, promises) => {
	// css chunk loading
	let installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
	if(installedChunkData !== 0) { // 0 means "already installed".

		// a Promise means "currently loading".
		if(installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if(/^(251|3813)$/.test(chunkId)) {
				// setup Promise in chunk cache
				const promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
				promises.push(installedChunkData[2] = promise);

				// start chunk loading
				const url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				const error = new Error();
				const loadingEnded = (event) => {
					if(__webpack_require__.o(installedChunks, chunkId)) {
						installedChunkData = installedChunks[chunkId];
						if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
						if(installedChunkData) {
							if(event.type !== "load") {
								const errorType = event && event.type;
								const realHref = event && event.target && event.target.href;
								error.message = 'Loading css chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realHref + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realHref;
								error.event = event;
								installedChunkData[1](error);
							} else {
								installedChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};

					loadStylesheet(chunkId, url, loadingEnded);
			} else installedChunks[chunkId] = 0;
		}
	}
};

// no prefetching

// no preloaded
// no hmr